import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=23364cfe&scoped=true"
import script from "./findPwd.vue?vue&type=script&lang=ts"
export * from "./findPwd.vue?vue&type=script&lang=ts"
import style0 from "./findPwd.vue?vue&type=style&index=0&id=23364cfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23364cfe",
  null
  
)

export default component.exports